<div class="pre-login">
    <div class="pre-login-col-1 h-100">
        <left-panel-onboarding></left-panel-onboarding>
    </div>
    <div class="pre-login-col-2">
    </div>
    <div class="pre-login-col-3">
        <div class="onboarding-canvas">
            <div class="font-400 font-size-20px line-h-25 mt-ipad-15">
                {{ "ManageAddress" | translate }}
            </div>
            <div class="form-group mt-50">
                <label class="no-mark">
                    {{ "PrimaryAddress" | translate }}
                </label>
                <input type="text" placeholder="Please enter">
            </div>
            <div class="form-group mt-24">
                <label class="no-mark">
                    {{ "Country" | translate }}
                </label>
                <input type="text" placeholder="Please enter">
            </div>
            <div class="form-group mt-24">
                <label class="no-mark">
                    {{ "BUILDINGNAME" | translate }}
                </label>
                <input type="text" placeholder="Please enter">
            </div>
            <div class="form-group mt-24">
                <label class="no-mark">
                    {{ "STREETNAME" | translate }}
                </label>
                <input type="text" placeholder="Please enter">
            </div>
            <div class="form-group mt-24">
                <label>{{"Nationality" | translate}}</label>
                <drop-down-list dropDownImage="false" dropDownSearch="false" [selectedValue]="this.selectedCity"
                    [dropDownData]="this.CityList" (itemselected)="onCityChange($event)">
                    {{this.selectedCity}}
                </drop-down-list>
            </div>
            <grid-row class="justify-content-between mt-50">
                <grid-col col="auto">
                    <button class="btn-back" (click)="back()">
                        <i class="icon-back"></i>
                    </button>
                </grid-col>
                <grid-col col="9" mobile="auto">
                    <button class="btn-dft" (click)="uploadId()">
                        {{ "SaveChanges" | translate }}
                    </button>
                </grid-col>
            </grid-row>
        </div>
    </div>
</div>